import ApiHandler from '@/api/base'

class TriggersApiHandler extends ApiHandler {
  async fetchTriggers({ searchString = null, id = null } = {}) {
    const url = ['/triggers', id].filter(Boolean).join('/')
    return await this.http.get(url, {
      params: {
        searchString
      }
    })
  }

  async createTrigger(payload) {
    return await this.http.post('/triggers', payload)
  }

  async getTriggerById({ id }) {
    return await this.fetchTriggers({ id })
  }

  async updateTrigger(payload) {
    return await this.http.put('/triggers', payload)
  }

  async deleteTrigger({ id }) {
    return await this.http.delete(`/triggers/${id}`)
  }
}

export default TriggersApiHandler
